import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { api } from "./api/client";

/** /teklif-kopyala ve /teklif-revize: yeni taslağı açar, düzenlemeye gider. */
export default function TeklifKopyala({ mode = "kopyala" }) {
  const { teklif_no: teklifNo } = useParams();
  const navigate = useNavigate();
  const [hata, setHata] = useState("");
  const revize = mode === "revize";

  useEffect(() => {
    if (!teklifNo) return undefined;
    let cancelled = false;
    (async () => {
      try {
        const { data } = await api.post(
          `/teklifler/${encodeURIComponent(teklifNo)}/${revize ? "revize" : "kopyala"}`
        );
        if (!cancelled) {
          navigate(`/teklif-olustur/${encodeURIComponent(data.teklif_no)}`, {
            replace: true,
          });
        }
      } catch (err) {
        const detail = err?.response?.data?.detail;
        if (!cancelled) {
          setHata(
            typeof detail === "string"
              ? detail
              : revize
                ? "Teklif revize edilemedi"
                : "Teklif kopyalanamadı"
          );
        }
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [teklifNo, navigate, revize]);

  return (
    <div style={{ padding: 24 }}>
      {hata
        ? hata
        : revize
          ? "Teklif revize ediliyor, güncel fiyat ve kur kaydediliyor…"
          : "Teklif kopyalanıyor, güncel fiyat ve kur kaydediliyor…"}
    </div>
  );
}
